module.exports = __webpack_public_path__ + "static/curso06-14d593840b2399aaf548da1bf6cfdfae.png";